import type { FetchOptions } from "../helpers/backendRequestHelpers";
import {
  fetchRequest,
  reactQueryGet,
  reactQueryPost,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";
import type { Space } from "../types/Space";

export interface IndexParams extends FetchOptions {
  params: Record<string, unknown>;
}

export interface IndexResponseData {
  count: number;
  has_next_page: boolean;
  page: number;
  per_page: number;
  records: Space[];
  sidebar_html: string;
}

const index = <T = unknown>({
  params = {},
  ...fetchRequestOptions
}: IndexParams) =>
  fetchRequest<T>(internalApi.spaces.index({ params }), {
    ...fetchRequestOptions,
    method: "GET",
  });

export interface ShowParams extends FetchOptions {
  id?: number;
}

const show = <T = unknown>({ id, ...fetchRequestOptions }: ShowParams) =>
  fetchRequest<T>(internalApi.spaces.show({ id }), {
    ...fetchRequestOptions,
    method: "GET",
  });

export interface ListParams extends FetchOptions {
  params: Record<string, unknown>;
}

const list = ({ params = {} }: ListParams): Promise<any> =>
  reactQueryGet(internalApi.spaces.index({ params }));

export interface AddMemberToSpaceParams {
  body: Record<string, unknown>;
  spaceId: number;
}

const addMemberToSpace = ({
  spaceId,
  body,
}: AddMemberToSpaceParams): Promise<any> =>
  reactQueryPost(internalApi.spaces.addMemberToSpace({ spaceId }), body);

export interface DestroyParams extends FetchOptions {
  id: number;
}

const destroy = <T = unknown>({ id, ...fetchRequestOptions }: DestroyParams) =>
  fetchRequest<T>(internalApi.spaces.destroy({ id }), {
    ...fetchRequestOptions,
    method: "DELETE",
  });

export interface ChatTranscriptParams extends FetchOptions {
  id?: string | number;
  params?: Record<string, unknown>;
}

const chatTranscript = ({
  id,
  params,
  ...fetchRequestOptions
}: ChatTranscriptParams) =>
  fetchRequest<unknown>(internalApi.chatSpaces.transcript({ id, params }), {
    method: "GET",
    ...fetchRequestOptions,
  });

export const spaceApi = {
  index,
  list,
  show,
  addMemberToSpace,
  destroy,
  chatTranscript,
};
